import React from "react";
import propTypes from "prop-types";

const getChildrenFCByDisplayName = (children, displayName) => 
    React.Children.map(children, (child) => 
        child.type.displayName === displayName ? child : null
    );


const FlagCard = ({background, children, ...rest}) => {
    const header = getChildrenFCByDisplayName(children, 'Header');
    const media = getChildrenFCByDisplayName(children, 'Media')
    const body = getChildrenFCByDisplayName(children, 'Body');
    const footer = getChildrenFCByDisplayName(children, 'Footer')
    let classList = `usa-card usa-card--flag ${rest.grid} ${rest.mediaRight? "usa-card--media-right":""}${rest.roundMedia? "round-media":""}`;
    return (
        <div className={classList}>
            <div className={`usa-card__container ${background} ${rest.border}`}>
                {header}
                {media}
                {body}
                {footer}
            </div>
        </div>
    )
}
const Header = ({children}) => <div className='usa-card__header'>{children}</div>;
Header.displayName = "Header";
FlagCard.Header = Header;

const Media = ({children, mediaRight, mediaStyle}) => {
    let classList = `usa-card__media ${mediaRight? "usa-card__media--inset":""} ${mediaStyle}`;
    return <div className={classList}>{children}</div>
};
Media.displayName = "Media";
FlagCard.Media = Media;

const Body = ({children}) => <div className='usa-card__body'>{children}</div>;
Body.displayName = "Body";
FlagCard.Body = Body;

const Footer = ({cardFooter, children}) => <div className={`usa-card__footer ${cardFooter}`}>{children}</div>;
Footer.displayName = "Footer";
FlagCard.Footer = Footer;

export default FlagCard;
FlagCard.propTypes = { 
    grid: propTypes.oneOfType([propTypes.string]),
    roundMedia: propTypes.oneOf([true, false]),
    background: propTypes.oneOfType([propTypes.string]),
    mediaRight: propTypes.oneOf([true, false]),
    border: propTypes.oneOfType([propTypes.string])
}
FlagCard.defaultProps = {
    grid: "desktop:grid-col",
    roundMedia: false,
    background: "transparent-bg",
    mediaRight: false,
    border: "border-0"
}
Media.propTypes = { 
    mediaRight: propTypes.oneOf([true, false]),
    mediaStyle: propTypes.oneOfType([propTypes.string])
}
Media.defaultProps = {
    mediaRight: false,
    mediaStyle: ""
}
Footer.propTypes = { 
    cardFooter: propTypes.oneOfType([propTypes.string]),
}
Footer.defaultProps = {
    cardFooter: ""
}
